export default __webpack_public_path__ + "static/media/vinciworks.d1180c04.svg";